export default __webpack_public_path__ + "static/media/FebDOM2026.ad178577.jpg";